import { useEffect, useRef, useState } from "react";

import { BasicModal, ListContentLoader } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { allTrackers } from "app/services/track/track";

import { useTopicsData } from "../../../api-client/demandSearchTrendsTopicsAPI";

import { TopicsDiscoverAllTopicsModalHeader } from "./TopicsDiscoverAllTopicsModalHeader";
import { TopicsDiscoverAllTopicsModalMainSection } from "./TopicsDiscoverAllTopicsModalMainSection";
import { TopicsDiscoverAllTopicsModalSearch } from "./TopicsDiscoverAllTopicsModalSearch";

const customStyles = {
    overlay: {
        padding: "40px 16px",
    },
    content: {
        display: "flex",
        "flex-direction": "column",
        height: "100%",
        maxHeight: "900px",
        width: "100%",
        maxWidth: "920px",
        padding: "0",
    },
};

type TopicsDiscoverExploreAllModalProps = {
    isOpen: boolean;
    onClose: () => void;
    predefinedUserTopic?: string;
    discoverCategory?: string;
};

export const TopicsDiscoverAllTopicsModal = ({
    isOpen,
    onClose,
    predefinedUserTopic,
    discoverCategory = "general",
}: TopicsDiscoverExploreAllModalProps) => {
    const { data, isLoading } = useTopicsData();
    const [activeCategoryName, setActiveCategoryName] = useState<string>();
    const initializedRef = useRef(false);

    useEffect(() => {
        if (data?.rawData && !initializedRef.current) {
            const initialCategory = predefinedUserTopic || Object.keys(data.rawData)[0];
            setActiveCategoryName(initialCategory);
            initializedRef.current = true;
        }
    }, [data, predefinedUserTopic]);

    useEffect(() => {
        if (predefinedUserTopic && initializedRef.current) {
            setActiveCategoryName(predefinedUserTopic);
        }
    }, [predefinedUserTopic]);

    return (
        <BasicModal
            shouldCloseOnOverlayClick
            shouldCloseOnEsc
            isOpen={isOpen}
            onRequestClose={onClose}
            customStyles={customStyles}
        >
            {isLoading ? (
                <Flex
                    width="100%"
                    height="100%"
                    alignItems="center"
                    justifyContent="center"
                >
                    <ListContentLoader />
                </Flex>
            ) : (
                <>
                    <TopicsDiscoverAllTopicsModalHeader />
                    <TopicsDiscoverAllTopicsModalSearch flattenedData={data.flattenedTopics} />
                    <TopicsDiscoverAllTopicsModalMainSection
                        data={data.rawData}
                        activeCategoryName={activeCategoryName}
                        setActiveCategoryName={setActiveCategoryName}
                    />
                </>
            )}
        </BasicModal>
    );
};
